'use client';

import { useEffect, useRef } from 'react';

export const useScrollLock = (locked) => {
  if (typeof document === 'undefined') return;
  const scroll = useRef(false);

  const lockScroll = () => {
    const html = document.documentElement;
    const body = document.getElementById('bodyWrapper');
    const innerBlock = body.querySelector(':scope > div');
    if (!body || !body.style || scroll.current || !innerBlock) return;

    const { top } = body.getBoundingClientRect();
    const scrollBarWidth = window.innerWidth - innerBlock.clientWidth;

    html.style.position = 'relative';
    body.style.paddingRight = `${scrollBarWidth}px`;
    body.style.top = `${top}px`;
    body.style.position = 'fixed';
    body.style.overflow = 'hidden';
    scroll.current = true;
  };

  const unlockScroll = () => {
    const html = document.documentElement;
    const body = document.getElementById('bodyWrapper');

    if (!body || !body.style || !scroll.current) return;

    const scrollY = body.style.top;
    html.style.position = '';
    html.style.overflow = '';
    body.style.position = '';
    body.style.overflow = '';
    body.style.paddingRight = '';
    body.style.top = '';
    window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);

    scroll.current = false;
  };

  useEffect(() => {
    if (locked) {
      lockScroll();
    } else {
      unlockScroll();
    }

    return () => {
      unlockScroll();
    };
  }, [locked]);
};
